'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { Suspense } from 'react';
import type { VaultV1Risk } from '@/lib/procedures/vaultV1Risk.contract';
import SectionErrorBoundary from '@/components/common/SectionErrorBoundary';
import type { GuardianMetadataItems, PendingTimelock } from '../VaultHeroPendingActions/types';
import { VaultRolesError, VaultRolesLoading } from './states';
import VaultRolesClient from './VaultRoles.client';
export interface VaultRolesLayoutProps {
  chainId: ChainId;
  owner: VaultV1Risk['owner'];
  curator: VaultV1Risk['curator'];
  guardian: VaultV1Risk['guardian'];
  pendingTimelocks: PendingTimelock[];
  currentGuardianMetadata: GuardianMetadataItems | undefined;
}
const VaultRolesLayout = t0 => {
  const $ = _c(10);
  const {
    chainId,
    owner,
    curator,
    guardian,
    pendingTimelocks,
    currentGuardianMetadata
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-foreground text-sm">Vault Roles</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <VaultRolesError />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <VaultRolesLoading />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== chainId || $[4] !== curator || $[5] !== currentGuardianMetadata || $[6] !== guardian || $[7] !== owner || $[8] !== pendingTimelocks) {
    t4 = <div className="gap-sm flex flex-col" id="vault-roles-section">{t1}<SectionErrorBoundary fallback={t2}><Suspense fallback={t3}><VaultRolesClient chainId={chainId} owner={owner} curator={curator} guardian={guardian} pendingTimelocks={pendingTimelocks} currentGuardianMetadata={currentGuardianMetadata} /></Suspense></SectionErrorBoundary></div>;
    $[3] = chainId;
    $[4] = curator;
    $[5] = currentGuardianMetadata;
    $[6] = guardian;
    $[7] = owner;
    $[8] = pendingTimelocks;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default VaultRolesLayout;